const translations = {
  "en": {
    "Friday": "Friday",
    "Lunch": "Noon Break",
    "Market Closed": "Market Closed",
    "Monday": "Monday",
    "Night Market": "Night Market",
    "Post-market": "Post-market",
    "Pre-market": "Pre-market",
    "Regular Market": "Regular Market",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Thursday": "Thursday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday"
  },
  "zh-tw": {
    "Friday": "星期五",
    "Lunch": "午間休市",
    "Market Closed": "休市中",
    "Monday": "星期一",
    "Night Market": "夜盤",
    "Post-market": "盤後",
    "Pre-market": "盤前",
    "Regular Market": "盤中",
    "Saturday": "星期六",
    "Sunday": "星期日",
    "Thursday": "星期四",
    "Tuesday": "星期二",
    "Wednesday": "星期三"
  }
};

export default translations;
